<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
    :hot-key-create-path="`/supplier-note/create/${this.baseView.id}`"
    :hot-key-grid-tab-index="2"
    :hot-key-create-route-id="model.SupplierCode"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Supplier"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.SupplierName"
        :secondaryLabel="model.SupplierCode"
        recordType="Supplier"
        v-if="model.SupplierCode"
      />
    </template>
    <div class="css-v2 split-view">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="noteGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @content-ready="addGridNoResults($event)"
                  :selection="{ mode: 'single' }"
                  v-if="model.SupplierCode"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Supplier-${baseView.id} Notes`,
                      columns
                    )
                  "
                  :row-alternation-enabled="true"
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager
                    :showInfo="true"
                    :showPageSizeSelector="false"
                    :infoText="'({2} items)'"
                    :visible="false"
                  />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #note-date-cell-template="{ data }">
                    <span>
                      {{
                        data.displayValue.dateWithOffset().toShortDateString() +
                        ", " +
                        data.displayValue.dateWithOffset().toShortTimeString()
                      }}</span
                    >
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.SupplierCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form v-if="loadingCompleted">
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
              >
                <template #contact="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary"
                      >{{ data.FirstName }} {{ data.Surname }}</span
                    >
                  </div>
                </template>
              </DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import validationEngine from "devextreme/ui/validation_engine";
import { SupplierService } from "../../_services/api/suppliers/supplier.service";
import { SupplierNoteService } from "../../_services/api/suppliers/supplier-note.service";
import {
  SupplierDetailTabs,
  SupplierDetailTabsVisibility,
  IsGrowerTabVisible,
} from "../../_models/tabdata/suppliers/supplier-detail-tabs";
import { SupplierContactService } from "../../_services/api/suppliers/supplier-contact.service";

export default {
  mixins: [BaseViewMixin],
  created() {
    this.selectedIndex = 2;
  },
  updated() {
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  components: {},
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          onClick: this.close,
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/supplier-note/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveSupplierNote(e);
          },
        },
        delete: {
          icon: "trash",
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickDelete();
            this.deleteSupplierNote(e);
          },
        },
        audit: {
          icon: "clock",

          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        NoteDate: "",
        ChangedBy: "",
        SupplierContactCode: "",
      },
      model: {
        Note: "",
        SupplierContactCode: null,
        SupplierContactLineNo: null,
        SupplierCode: "",
        SupplierName: "",
        NoteDate: new Date(),
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        RecordId: "00000000-0000-0000-0000-000000000000",
        LineNo: 0,
      },
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Notes",
          message: "Get Started, Add a Note",
        },
      },
    };
  },
  computed: {
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    initialFilter() {
      return [["SupplierCode", "=", this.model.SupplierCode]];
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "NoteDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Date",
            },
            {
              dataField: "SupplierContactCode",
              gcLabel: "Contact",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: SupplierContactService.dataSourceConfigList(
                  "api/SupplierContactList",
                  {
                    select: [
                      "LineNo",
                      "RecordId",
                      "FirstName",
                      "Surname",
                      "RecordIdAsString",
                    ],
                    filter: [
                      ["Inactive", "=", "N"],
                      "and",
                      ["SupplierCode", "=", this.model.SupplierCode],
                    ],
                  }
                ),
                valueExpr: "RecordIdAsString",
                searchExpr: ["FirstName", "Surname"],
                searchMode: "contains",
                itemTemplate: "rep-item-template",
                searchEnabled: true,
                displayExpr: function (data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
              },
            },
          ]),
        },
      ];
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "NoteDate",
              gcType: "Datetime",
              gcLabel: "Date / Time",
            },
            {
              dataField: "SupplierContactLineNo",
              gcLabel: "Contact",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: SupplierContactService.dataSourceConfig(
                  "api/SupplierContact",
                  {
                    select: ["LineNo", "RecordId", "FirstName", "Surname"],
                    filter: [
                      ["Inactive", "=", "N"],
                      "and",
                      ["SupplierCode", "=", this.model.SupplierCode],
                    ],
                  }
                ),
                valueExpr: "LineNo",
                searchExpr: ["FirstName", "Surname"],
                searchMode: "contains",
                showClearButton: true,
                itemTemplate: "contact",
                searchEnabled: true,
                onItemClick: this.onContactItemClicked,
                displayExpr: function (data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
              },
            },
            {
              dataField: "Note",
              gcLabel: "Note",
              gcType: "String",
              editorType: "dxTextArea",
              editorOptions: {
                maxLength: 1000,
                height: 200,
              },
              required: true,
            },
          ]),
        },
      ];

      return formFields;
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Date",
          dataField: "NoteDate",
          gcType: "Datetime",
          gcSubType: "PrimaryDate",
          sortOrder: "desc",
          dataType: "datetime",
          customizeText: function (cellInfo) {
            return cellInfo.valueText;
          },
          cellTemplate: "note-date-cell-template",
        },

        {
          gcLabel: "Contact",
          dataField: "SupplierContactFullName",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(220),
        },

        {
          gcLabel: "Note",
          dataField: "Note",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
        },
        {
          gcLabel: "Changed By",
          dataField: "ChangedBy",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(120),
        },
      ]);
    },
    dataSourceConfig() {
      return SupplierNoteService.dataSourceConfig("api/SupplierNoteList", {
        select: [
          "Note,LineNo,SupplierCode,RecordId,NoteDate,SupplierContactCode,SupplierContactFullName,ChangedBy",
        ],
        // sort: [{ selector: "NoteDate", desc: true }],
        filter: [["SupplierCode", "=", this.model.SupplierCode]],
      });
    },
    tabs() {
      // Almondco - 2116 - Grower Master: repointed from an inline array to
      // the shared tab-data module (also fixes the pre-existing Transactions
      // link, which pointed at baseView.id - the note's RecordId in
      // review/edit mode, not the Supplier code the other tabs used).
      // Gating on loadingCompleted is required for the Grower visibility
      // flag set in handleLocalRouteChange() to ever reach the rendered
      // tab strip - see supplier-detail.vue's tabs() for why.
      if (this.loadingCompleted) return SupplierDetailTabs(this.model.SupplierCode);
      else return [];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  methods: {
    onContactItemClicked(e) {
      this.model.SupplierContactCode = e.itemData.RecordId;
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["noteGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.SupplierCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router
            .push({
              path: `/supplier-note/${this.baseView.id}`,
            })
            .then(() => {
              let grid = this.$refs["noteGrid"].instance;
              grid.updateDimensions();
            });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["noteGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.SupplierCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router
          .push({
            path: `/supplier-note/${this.baseView.id}`,
          })
          .then(() => {
            let grid = this.$refs["noteGrid"].instance;
            grid.updateDimensions();
          });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/supplier",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.model.Note = "";
              this.model.SupplierContactCode = null;
              this.model.SupplierContactLineNo = null;
              this.model.NoteDate = new Date();
              this.model.RecordId = "00000000-0000-0000-0000-000000000000";
              this.model.DateChanged = "";
              this.model.DateCreated = "";
              this.model.ChangedBy = "";
              this.model.CreatedBy = "";
              this.model.LineNo = 0;

              this.baseView.id = this.model.SupplierCode;

              this.$router.push({
                path: `/supplier-note/create/${this.baseView.id}`,
              });
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
      );
    },
    handleLocalRouteChange() {
      let that = this;
      this.showLoading(true);
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.model.RecordId = this.baseView.id;
        this.getRecord().then(async (response) => {
          if (response.data.value.length > 0) {
            that.model.Note = response.data.value[0].Note;
            that.model.SupplierContactLineNo = null;
            that.model.SupplierContactCode =
              response.data.value[0].SupplierContactCode;
            that.model.SupplierCode = response.data.value[0].SupplierCode;
            that.model.SupplierName = response.data.value[0].Supplier.Name;

            that.model.NoteDate =
              response.data.value[0].NoteDate == "" ||
              response.data.value[0].NoteDate == null
                ? null
                : new Date(response.data.value[0].NoteDate);

            that.model.RecordId = response.data.value[0].RecordId;
            that.model.DateChanged = response.data.value[0].DateChanged;
            that.model.DateCreated = response.data.value[0].DateCreated;
            that.model.ChangedBy = response.data.value[0].ChangedBy;
            that.model.CreatedBy = response.data.value[0].CreatedBy;
            that.model.LineNo = response.data.value[0].LineNo;

            // Must be awaited before loadingCompleted flips to true below -
            // tabs() only re-evaluates when loadingCompleted actually
            // changes, so setting it before this resolves would lock in
            // the stale/default visibility value permanently.
            await IsGrowerTabVisible(
              response.data.value[0].Supplier.SupplierTypeCode
            ).then((visible) => {
              SupplierDetailTabsVisibility({ text: "Grower", value: visible });
            });

            if (that.model.SupplierContactCode != null) {
              SupplierContactService.getByRecordId(
                that.model.SupplierContactCode
              ).then((response3) => {
                if (response3.data.value.length > 0) {
                  that.model.SupplierContactLineNo =
                    response3.data.value[0].LineNo;
                }
              });
            }

            // that.refreshView();
          }
          that.loadingCompleted = true;
          that.showLoading(false);
        });
      } else {
        if (!that.model.SupplierCode) {
          SupplierService.getByCode(that.baseView.id).then(async (response2) => {
            //     // eslint-disable-next-line no-debugger
            // debugger;
            if (response2.data.value.length > 0) {
              that.model.SupplierCode = response2.data.value[0].Code;
              that.model.SupplierName = response2.data.value[0].Name;
              // that.refreshView();
              await IsGrowerTabVisible(
                response2.data.value[0].SupplierTypeCode
              ).then((visible) => {
                SupplierDetailTabsVisibility({
                  text: "Grower",
                  value: visible,
                });
              });
            }
            this.loadingCompleted = true;
          });
        } else {
          if (this.showRightContainer) this.loadingCompleted = true;
        }
        that.showLoading(false);
      }
    },
    contactExistsRuleCallback(params) {
      return new Promise((resolve) => {
        if (this.model.SupplierContactCode == "") {
          resolve(true);
        } else {
          SupplierContactService.getBySupplierCodeLineNo(
            this.model.SupplierCode,
            params.value
          ).then((response) => {
            if (
              response.data.value.length > 0 &&
              response.data.value[0].Inactive == "N"
            ) {
              this.model.SupplierContactCode = response.data.value[0].RecordId;
              resolve(true);
            } else {
              this.model.SupplierContactCode = null;
              resolve(false);
            }
          });
        }
      });
    },
    async getRecord() {
      return SupplierNoteService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router
        .push({
          path: `/supplier-note/review/${selectedRowsData[0].RecordId}`,
        })
        .then(() => {
          let grid = this.$refs["noteGrid"].instance;
          grid.updateDimensions();
        });
    },

    async deleteSupplierNote() {
      let that = this;

      let confirmLeaving = await this.$confirm(
        `Are you sure you want to delete ${this.model.Note}?`,
        "Delete Note"
      );

      if (confirmLeaving) {
        this.showLoading(true);
        await SupplierNoteService.delete({
          RecordId: this.model.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["noteGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(error, "Supplier Note delete failed");
          });
      }
    },
    async saveSupplierNote(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);

      let payload = {
        Note: this.model.Note,
        SupplierContactCode:
          this.model.SupplierContactCode == ""
            ? null
            : this.model.SupplierContactCode,
        SupplierCode: this.model.SupplierCode,
        NoteDate: this.model.NoteDate,
        RecordId: this.model.RecordId,
        LineNo: this.model.LineNo,
      };

      // if (payload.SupplierContactCode == "") {
      //   delete payload.SupplierContactCode;
      // }

      await SupplierNoteService.save(this.baseView.mode, payload)
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
            this.model.LineNo = res.data.LineNo;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveSupplierNote", res);
          this.$notify(
            `Supplier Note ${this.model.Note} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/supplier-note/review/${this.model.RecordId}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Supplier Note save failed");
        });
    },
  },
};
</script>
